import { useFeatureFlagStore } from '../store/feature-flag-store';
import { FeatureAccess } from './useFeatureAccessControls';

const EXPERIMENTAL_PORT = '4322';
const REGULAR_PORT = '4321';

/**
 * Determines experimental mode based on environment:
 * - Deployed: hostname starts with 'experimental.' (e.g. experimental.beta.finspace.finergy.amazon.dev)
 * - Local: port 4322 is experimental, 4321 is regular
 */
const isExperimentalHost = (): boolean => {
  const { hostname, port } = window.location;
  if (hostname === 'localhost') {
    return port === EXPERIMENTAL_PORT;
  }
  return hostname.startsWith('experimental.');
};

/**
 * Navigates to the experimental or regular domain.
 */
const navigateToMode = (experimental: boolean): void => {
  const { hostname, protocol, pathname } = window.location;

  if (hostname === 'localhost') {
    const targetPort = experimental ? EXPERIMENTAL_PORT : REGULAR_PORT;
    window.location.href = `${protocol}//localhost:${targetPort}${pathname}`;
    return;
  }

  let targetHostname: string;
  if (experimental) {
    // beta.finspace... → experimental.beta.finspace...
    targetHostname = `experimental.${hostname}`;
  } else {
    // experimental.beta.finspace... → beta.finspace...
    targetHostname = hostname.replace(/^experimental\./, '');
  }
  window.location.href = `${protocol}//${targetHostname}${pathname}`;
};

export const useExperimentalMode = () => {
  const { hasFeatureAccess } = useFeatureFlagStore();

  return {
    experimentalModeEnabled: isExperimentalHost(),
    hasFeatureAccess: hasFeatureAccess(FeatureAccess.EXPERIMENTAL_MODE),
    toggleExperimentalMode: () => navigateToMode(!isExperimentalHost()),
  };
};
